// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentId, ContentIdList } from "../schema";
import { serialize_ContentId_internal, deserialize_ContentId_internal } from "./ContentId";

export function serialize_ContentIdList_internal(value: ContentIdList): unknown {
  return ((value: { items: ContentId[] }): unknown => {
    return {
      items: ((value: ContentId[]): unknown => {
        return value.map((value: ContentId): unknown => {
          return serialize_ContentId_internal(value);
        });
      })(value["items"]),
    };
  })(value);
}
export function serialize_ContentIdList(obj: ContentIdList): string {
  return renderJsonWithNumbersAsBigint(serialize_ContentIdList_internal(obj));
}
export function deserialize_ContentIdList_internal(value: unknown): ParserResult<ContentIdList> {
  return ((
    value: unknown,
  ): ParserResult<{
    items: ContentId[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ContentIdList]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ContentIdList]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "items")) {
      return { success: false, reason: `[#/components/schemas/ContentIdList/items]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'items'.` };
    }
    const parsed_items = ((): ParserResult<ContentId[]> => {
      return ((value: unknown): ParserResult<ContentId[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ContentIdList/items]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<ContentId> => {
          return deserialize_ContentId_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ContentIdList/items]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["items"]);
    })();
    if (!parsed_items.success) {
      return { success: false, reason: parsed_items.reason };
    }
    return { success: true, value: { items: parsed_items.value } };
  })(value);
}
export function deserialize_ContentIdList(str: string): ParserResult<ContentIdList> {
  return deserialize_ContentIdList_internal(parseJsonWithNumbersAsBigint(str));
}
